<template>
  <div class="users">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>数据权限列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/datarights/create')"
          >添加</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="6">
          <el-input
            placeholder="请输入账号或用户姓名"
            v-model="params.uname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryAllUserDataRight"
            ></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="9">&nbsp;</el-col>
        <el-col :span="9">
          <el-date-picker
            v-model="params.date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col> -->
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="allDataRights" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allDataRights.length"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :dataRight="editDataRight"
      @confirm="changeDataRight"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit.vue'
import { brequest } from '@/utils/brequest'
import { DATA_RIGHT_TYPE } from '@/utils/params'

export default {
  components: {
    TzTable,
    Edit
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    deleteFn(row) {
      console.log('删除2', row)

      this.$confirm('此操作将永久删除该数据权限, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteDataRight(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async deleteDataRight(dataRight) {
      this.$loading({
        text: '数据权限删除中'
      })
      let ret = await brequest({
        url: '/user/deleteUserDataRight',
        data: { id: dataRight.id }
      })
      this.$loading().close()
      if (ret) {
        this.$message({
          message: '数据权限删除成功',
          type: 'success'
        })
        this.allDataRights = this.allDataRights.filter(
          (rec) => rec.id !== dataRight.id
        )
      }
    },
    queryTypeText(rtype) {
      return DATA_RIGHT_TYPE.find((rec) => rec.value === rtype).label
    },
    async queryAllUserDataRight() {
      let ret = await brequest({
        url: '/user/queryAllUserDataRight',
        data: { name: this.params.uname || '' }
      })
      this.allDataRights = ret.map((rec) => {
        return {
          ...rec,
          rightTypeTxt: this.queryTypeText(rec.rightType)
        }
      })
    },
    async changeDataRight(dataRight) {
      this.$loading({
        text: '数据权限更新中'
      })
      let rightText = dataRight.rightText || '-'
      let ret = await brequest({
        url: '/user/updateUserDataRight',
        data: {
          id: dataRight.id,
          userId: dataRight.userId,
          rightText: rightText
        }
      })
      this.$loading().close()
      if (ret) {
        this.editState = false
        this.$message({
          message: '数据权限更新成功',
          type: 'success'
        })
        this.allDataRights.find((rec) => rec.id === dataRight.id).rightText =
          rightText
      }
    }
  },
  data() {
    return {
      // 编辑表单数据
      editState: false,
      editDataRight: {},
      // 筛选模型
      params: {
        uname: '',
        // date: [],
        pagenum: 1
      },
      // 表格列
      columns: [
        { title: '账号', field: 'loginName' },
        { title: '所属角色', field: 'roleName' },
        { title: '姓名', field: 'userName' },
        { title: '权限类型', field: 'rightTypeTxt' },
        { title: '权限内容', field: 'rightText' },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('修改', row)
                this.editDataRight = JSON.parse(JSON.stringify(row))
                // 1 显示弹框
                this.editState = true
                // 2.
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => this.deleteFn(row)
            }
          ]
        }
      ],
      // 表格数据
      dataRightList: [],
      allDataRights: []
    }
  },
  mounted() {
    this.queryAllUserDataRight()
  }
}
</script>

<style lang="scss" scoped>
// history
// .history {
// }
</style>
